import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Get commitment of traders for given commodity
 * @param {object} _this: context variables
 */
export async function getCommitmentTraders(_this) {
  let pk;
  Object.assign(_this.loading, { historical: true });
  if (_this.selectedAssetType === 0) {
    pk =
      _this.cotPKByCurrency[
        _this.currencySpecsFiltered[_this.selectedAsset0].pk_i_idcurrency
      ];
  } else if (_this.selectedAssetType === 1) {
    pk =
      _this.cotPKByCommodity[
        _this.commoditySpecsFiltered[_this.selectedAsset1].pk_idcommodity
      ];
  } else if (_this.selectedAssetType === 2) {
    pk =
      _this.cotPKByIndex[_this.indexSpecs[_this.selectedAsset2].pk_i_idindexes];
  }
  // _this[fieldShowLoadingName] = true;
  let params = {
    method: "GET",
    endpoint: "cot_hist",
    content_type: "application/json",
    query_params: {
      format: "json",
      pk: pk
    }
  };
  return apiService
    .getAll(params)
    .then(function(data) {
      parseData(data, _this);
    })
    .catch(function(error) {
      Object.assign(_this.loading, { historical: false });
      console.error(error);
    });
}

export function parseData(data, _this) {
  let keys = Object.keys(data[data.length - 1]);
  keys = keys.filter(
    d =>
      [
        "date",
        "close",
        "open_interest",
        "non_commercial_net",
        "commercial_net",
        "non_rep_net",
        "highlight"
      ].indexOf(d) === -1
  );
  Object.assign(_this.allData, { keys: keys });
  data.forEach(function(d) {
    d.date = timeParseNull2(d.date);
    d.zero = 0;
  });
  // filter data with necessary information
  let dataFilter = data.map(({ ...rest }) => {
    keys.forEach(key => delete rest[key]);
    return rest;
  });
  Object.assign(_this.allData, { historical: dataFilter });
  _this.formatVars["tableFormat"].forEach(net => _this.intervalTable(net));
  Object.assign(_this.loading, { historical: false });
}

/**
 * Get commitment of traders codes
 * @param {object} _this: context variables
 */
export async function getCommitmentTradersFiltersData(_this) {
  let params = {
    method: "GET",
    endpoint: "cot_codes",
    content_type: "application/json",
    query_params: {
      format: "json"
    }
  };
  return apiService
    .getAll(params)
    .then(function(data) {
      Object.assign(_this.allData, { filterData: data });
      Object.assign(_this.loading, { cotFilter: false });
    })
    .catch(function(error) {
      console.error(error);
    });
}
